import React from "react";

import { SVG_DATA } from "./svgData";

interface IconProps {
    name: string;
    className?: string;
    svgClassName?: string;
    alt?: string;
    width?: number;
    height?: number;
}

/**
 * Renders an inline SVG icon from a predefined set of icons.
 *
 * This component is designed for use in SSR components to prerender SVGs,
 * ensuring that icons are available without additional network requests or client-side rendering.
 *
 */
export const SVGIcon: React.FC<IconProps> = ({
    name,
    className = "",
    svgClassName,
    width,
    height,
    alt,
    ...restProps
}) => {
    const icon = SVG_DATA[name as keyof typeof SVG_DATA];

    if (!icon) {
        console.warn(`Icon "${name}" not found`);
        return null;
    }

    return (
        <span className={`${className}`} {...restProps}>
            {React.cloneElement(icon, {
                className: svgClassName,
                width: width,
                height: height,
                alt: alt,
            })}
        </span>
    );
};
